module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step2_Image14.299859f4.jpg";